<template>
  <div class="page-layout">
    <m-scrollbar>
      <menu-list />
    </m-scrollbar>
  </div>
</template>

<script>
import MenuList from '@/components/rules/menu/List'
import MScrollbar from '@/components/MScrollbar'

export default {
  components: { MenuList, MScrollbar }
}
</script>

<style scoped>
.page-layout { height: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/rules/menu/View.vue